"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTestId = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
function generateTestId(testId, suffix) {
    if (typeof testId === 'undefined' ||
        typeof suffix === 'undefined' ||
        testId === null ||
        suffix === null ||
        testId === '' ||
        suffix === '') {
        return undefined;
    }
    return "".concat(testId, "-").concat((0, kebabCase_1.default)(suffix));
}
exports.generateTestId = generateTestId;
//# sourceMappingURL=test-helpers.js.map